import { Injectable } from '@angular/core';
import { ModelService } from '../../services/model.service';

export interface ContactUsModel {
	FullName: string,
	Email: string,
	Topic: string,
	Message: string
}

@Injectable()
export class FeedbackService extends ModelService {

	private urls = {
		send: '/v2/feedback/send.json',
		contact: '/v2/contact-us.json'
	};

	public send(description: string): Promise<void> {
		let params: {
			Description: string
		};

		params = {
			Description: description
		};

		return this.post(this.urls.send,
			(): void => {
		}, params);
	}

	public contactUs(data: ContactUsModel): Promise<void> {
		return this.post(this.urls.contact,
			(): void => {
		}, data);
	}
}
